import { render, staticRenderFns } from "./ossList.vue?vue&type=template&id=1cf3c97e&scoped=true&"
import script from "./ossList.vue?vue&type=script&lang=js&"
export * from "./ossList.vue?vue&type=script&lang=js&"
import style0 from "./ossList.vue?vue&type=style&index=0&id=1cf3c97e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3c97e",
  null
  
)

export default component.exports